import _ from "lodash";
import { axiosInstance } from "./globals";
import * as userService from "./userService";

import { DataSourceResult } from "@/model/DataSourceResult";
import { DataSourceRequest } from "@/model/DataSourceRequest";
import { MeetingFilter } from "@/model/filters";

export interface featureConfig {
  code: string;
  name: string;
  description: string;
  isDefault:number;
}

///interface chức năng cho đăng ký gói cước
export interface featuresToSubscriptionPlan {
 subscriptionPlanId : number;
 features: {
    featureId: any;
    // isActive: number;
  }[];
}

//interface chức năng cho chỉnh sửa gói cước
export interface SubscriptionFeatureResponse {
  data: {
    subscriptionPlanId: number;
    subscriptionPlanName: string;
    features: {
      featureId: number;
      featureName: string;
      featureCode: string;
      featureDescription: string;
      isActive: number;
    }[];
  }
}

///Lấy danh sách chức năng
export async function getAll(page: number, pageSize: number, keyword?: string): Promise<DataSourceResult<any>> {
  const headers = userService.getAuthHeaders();
  const body: DataSourceRequest = {
    page,
    pageSize,
    filters: keyword?   
    [
      { field: "code", operator: "contains", value: keyword, logic: "or"  },
      { field: "name", operator: "contains", value: keyword, logic: "or"  },
      { field: "description", operator: "contains", value: keyword, logic: "or"  }
    ]: [],
    sorts: [{ field: "CreatedAt", dir: "desc" }]
  };

  const res = await axiosInstance.post("/FeatureConfig/GetAll", body, { headers });
  return res.data.data;
}

///get chức năng theo code
export async function getByCode(code: string) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.get("/FeatureConfig/GetByCode", {
    params: { code }, headers
  })).data;
}

///tạo mới chức năng
export async function createFeatureConfig(configData: featureConfig) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/FeatureConfig/Create", configData, { headers })).data;
}

///chỉnh sửa chức năng
export async function updateByCode(configData: featureConfig) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/FeatureConfig/UpdateByCode", configData, { headers })).data;
}

///xóa chức năng theo mã code
export async function deleteByCode(code: string) {
  const headers = userService.getAuthHeaders();
  const body = { code };

  return (await axiosInstance.post("/FeatureConfig/DeleteByCode", body, { headers })).data;
}

///thêm chức năng cho phép gói cước sử dụng
export async function addFeaturesToSubscriptionPlan(featuresSub: featuresToSubscriptionPlan) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/SubscriptionPlanFeature/AddFeaturesToSubscriptionPlan", featuresSub, { headers })).data;
}

///get chức năng gói cước đang sử dụng
export async function getFeaturesBySubscriptionPlanId(subscriptionPlanId: number) {
  const headers = userService.getAuthHeaders();
  const res = await axiosInstance.get(`/SubscriptionPlanFeature/GetFeaturesBySubscriptionPlanId/${subscriptionPlanId}`, {
    headers
  });

  return res.data;
}
